var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.136 1.432a.41.41 0 00-.409.409v3.424C13.691 3.973 12 2.455 9 2.455A6.551 6.551 0 002.455 9 6.552 6.552 0 009 15.545c2.93 0 5.525-1.97 6.308-4.791a.41.41 0 00-.789-.219A5.742 5.742 0 019 14.727 5.733 5.733 0 013.273 9 5.733 5.733 0 019 3.273c2.75 0 4.231 1.389 5.212 2.659h-3.576a.41.41 0 10.001.818h4.5a.409.409 0 00.408-.41v-4.5a.409.409 0 00-.409-.408",
    fill: "#B5B5B5",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "8bc7c2d820b6a23b3889fe291d061883.svg";
export { SvgIconRestore as ReactComponent };